import { render } from "./TaxReceiptToggle.vue?vue&type=template&id=717d0548"
import script from "./TaxReceiptToggle.vue?vue&type=script&lang=js"
export * from "./TaxReceiptToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__